import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";
import { CreateClientUserReqData } from "./CreateClientUserReqData";

const ENDPOINT = "/usermanagement/createuser";

export class CreateClientUserCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    clientUserReqData: CreateClientUserReqData;

    constructor(clientUserReqData: CreateClientUserReqData) {
        super();
        this.clientUserReqData = clientUserReqData;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.clientUserReqData);
        return new ServiceResponseData(res);
    }
}
